







































































































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import OnClickOutside from './OnClickOutside.vue';
import { Getter, Action, Mutation } from 'vuex-class';
import SidebarLink from '@/components/SidebarLink.vue';
import ProjectsSelect from '@/views/ProjectsSelect.vue';
import UserMenu from '@/components/UserMenu.vue';
import { RouterHelper } from '../router';
import Transformation from '../classes/transformation';
import { ApiV2Service } from '@/services/api.base.service';
import JobMenu from '@/components/JobMenu.vue';
import JobHistory from '@/views/JobHistory.vue';
import OrganisationSelect from '@/components/OrganisationSelect.vue';
import ConnectivityService from '@/services/connectivity.service';
import AccountSelect from '@/components/AccountSelect.vue';

@Component({
  components: {
    AccountSelect,
    OrganisationSelect,
    JobHistory,
    JobMenu,
    SidebarLink,
    ProjectsSelect,
    OnClickOutside,
    UserMenu,
  },
})
export default class Sidebar extends Vue {

  @Prop({default: ''}) private backRoute!: string;
  @Prop({default: null}) private backAction: any;

  private selectedProject: any = null;
  private selectedProjectId: any = null;
  private userMenuShown: boolean = false;
  private jobMenuShown: boolean = false;
  private jobHistoryShown: boolean = false;
  private adminMenuShown: boolean = true;
  private productMenuShown: boolean = false;
  private mobileMenuOpen: boolean = false;

  @Getter private hasTTISettings!: boolean;
  @Getter private isSidebarCollapsed!: boolean;
  @Getter private activeProject: any;
  @Getter private login: any;
  @Getter private activeOrganisation: any;
  @Getter private activeOrganisationId!: number;
  @Getter private activeAccountId!: number;
  @Getter private activeProjectId!: number;
  @Getter private userDetails: any;
  @Getter private hasPermission: any;
  @Getter private isImpersonated!: boolean;
  private isCompose: boolean = false;
  private isPublish: boolean = false;
  private isAccounts: boolean = false;
  private isConsume: boolean = false;
  private isInventory: boolean = false;
  private isSubscriptions: boolean = false;
  private menuBackRoute: string = '';
  private hasNRInstance: boolean = false;
  private settingsLoading: boolean = false;

  @Action private addOrganisationCountsAsync: any;
  @Getter private organisationCounts: any;
  @Action private addProjectCountsAsync: any;
  @Getter private projectCounts: any;

  // List of getters to watch for changes on
  @Getter private devices: any;
  @Getter private sites: any;
  @Getter private users: any;
  @Getter private tasks: any;
  @Getter private projects: any;
  @Getter private versions: any;

  private async created() {
    this.selectedProject = this.activeProjectId ? this.activeProjectId : null;
    this.selectedProjectId = this.activeProjectId ? this.activeProjectId : null;
    this.setIsCompose();
    this.setIsPublish();
    this.setIsAccounts();
    this.setIsConsume();
    this.setIsSubscriptions();
    this.setIsInventory();
    this.menuBackRoute = this.backRoute;
    await this.getCounts();

    if (this.isPublish) {
      await this.checkForNRInstance();
    }
  }

  private async getCounts() {
    if (this.isCompose) {
      if (!this.activeProjectId) {
        await this.addOrganisationCountsAsync();
      } else {
        await this.addOrganisationCountsAsync();
        await this.addProjectCountsAsync();
      }
    } else if (this.isInventory) {
      await this.addOrganisationCountsAsync();
    }
  }

  private getCountSuffix(originalCount: number): string {
    const digitCount = originalCount.toString().length;
    const index = Math.ceil((digitCount - 3) / 3);
    const suffix = ['k', 'M', 'G'];
    if (digitCount < 4) {
      return originalCount.toString();
    } else {
      return (originalCount / Math.pow(1000, index)).toFixed(1).replace(/\.0$/, '') + suffix[index - 1];
    }
  }

  // Setup data watchers
  @Watch('devices.total')
  private async onDevicesChanged(): Promise<void> {
    await this.getCounts();
  }
  @Watch('sites.total')
  private async onSitesChanged(): Promise<void> {
    await this.getCounts();
  }
  @Watch('users.length')
  private async onUsersChanged(): Promise<void> {
    await this.getCounts();
  }
  @Watch('tasks.total')
  private async onTasksChanged(): Promise<void> {
    await this.getCounts();
  }
  @Watch('projects.length')
  private async onProjectsChanged(): Promise<void> {
    await this.getCounts();
  }
  @Watch('versions', { deep: true })
  private async onVersionsChanged(): Promise<void> {
    await this.getCounts();
  }
  @Watch('gateways.total')
  private async onGatewaysChanged(): Promise<void> {
    await this.getCounts();
  }

  private setIsCompose() {
    this.isCompose = RouterHelper.isCompose();
  }

  private setIsPublish() {
    this.isPublish = RouterHelper.isPublish();
  }

  private setIsAccounts() {
    this.isAccounts = RouterHelper.isAccounts();
  }

  private setIsInventory() {
    this.isInventory = RouterHelper.isInventory();
  }


  private setIsConsume() {
    this.isConsume = RouterHelper.isConsume();
  }

  private setIsSubscriptions() {
    this.isSubscriptions = RouterHelper.isSubscriptions();
  }

  private getBackAction() {
    if (this.backAction !== null) {
      return this.backAction();
    }
    return false;
  }

  private backLinkSet() {
    return (this.menuBackRoute !== null && this.menuBackRoute.length) || (this.backAction !== null);
  }

  private toggleSidebar() {
    this.$store.commit('setSidebarCollapsed', !this.isSidebarCollapsed);
  }

  private toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  private showProductMenu() {
    this.productMenuShown = true;
  }
  private hideProductMenu() {
    this.productMenuShown = false;
  }

  private toggleJobMenu() {
    this.jobMenuShown = this.mobileMenuOpen ? true : !this.jobMenuShown;
  }
  private toggleUserMenu() {
    this.userMenuShown = this.mobileMenuOpen ? true : !this.userMenuShown;
  }
  private hideUserMenu() {
    this.userMenuShown = false;
  }

  private showAdminMenu() {
    this.$set(this, 'adminMenuShown', true);
  }
  private toggleAdminMenu() {
    this.adminMenuShown = !this.adminMenuShown;
  }
  private hideAdminMenu() {
    this.adminMenuShown = false;
  }

  private getOrgRoute(route: string) {
    return `/organisation/${this.activeOrganisationId}${route}`;
  }

  private getAccountRoute(route: string) {
    return `/account/${this.activeAccountId}${route}`;
  }

  private getPublishOrgRoute(route: string) {
    return `/organisation/${this.activeOrganisationId}/publish${route}`;
  }

  private getConsumeOrgRoute(route: string) {
    return `/organisation/${this.activeOrganisationId}/consume${route}`;
  }

  private getInventoryOrgRoute(route: string) {
    return `/organisation/${this.activeOrganisationId}/inventory${route}`;
  }

  private getAdminSubscriptionsRoute(route: string) {
    return `/admin/subscriptions${route}`;
  }

  private async checkForNRInstance(): Promise<void> {
    try {
      const { success } = await ApiV2Service.get(`organisation/${this.activeOrganisationId}/applications/nodered`);
      this.hasNRInstance = success === 'ok';
    } catch (e: any) {
      this.hasNRInstance = false;
    }
  }
}
